export interface SSOExternalUserGridListDto {
  id: number;
  nameSurname: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
  sendSmsVerification: boolean;
  sendEmailVerification: boolean;
  contentLanguage: LanguageTypes;
}

export interface SSOExternalUserDto {
  id: number;
  nameSurname: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
  sendSmsVerification: boolean;
  sendEmailVerification: boolean;
  contentLanguage: LanguageTypes;
}

export interface SSOExternalUserCreateDto {
  nameSurname: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
  sendSmsVerification: boolean;
  sendEmailVerification: boolean;
  contentLanguage: LanguageTypes;
}

export interface SSOExternalUserUpdateDto {
  id: number;
  nameSurname: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
  sendSmsVerification: boolean;
  sendEmailVerification: boolean;
  contentLanguage: LanguageTypes;
}

export interface FilteredResultRequestDto {
  orderBy: string;
  orderType: string;
  searchText: string;
  columns: { [key: string]: string }[];
}
export interface SSOPermissionDto {
  sSOPermissionId: number;
  permissionKey: string | undefined;
}

export interface SSOPermissionListDto {
  sSOExternalUserId: number;
  permissionsList: SSOPermissionDto[];
}
export interface SSOPermissionCreateDto {
  sSOExternalUserId: number;
  permissionsList: SSOPermissionDto[];
}
export interface SSOExternalRoleDto {
  id: number;
  roleIds: string | undefined;
}

export enum LanguageTypes {
  Turkish = 1,
  English = 2,
}
